import {
  typographyVariantScales,
  typographyVariants
} from "./chunk.TSLPWEGG.js";
import {
  displayLarge,
  displayMedium,
  displaySmall,
  headingLarge,
  headingMedium,
  headingSmall,
  headingXLarge,
  headingXSmall,
  headingXXSmall,
  headingXXXSmall,
  labelLarge,
  labelMedium,
  labelSmall,
  labelXSmall,
  labelXXSmall,
  paragraphLarge,
  paragraphMedium,
  paragraphSmall,
  paragraphXSmall,
  tableData,
  tableHeader
} from "./chunk.GAOIIZQS.js";
import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  o,
  r
} from "./chunk.4JTBA2KG.js";

// src/components/typography/typography.styles.ts
function generateVariantClasses() {
  const classes = typographyVariants.reduce((typeClasses, type) => {
    typeClasses += typographyVariantScales.reduce((scaleClasses, scale) => {
      scaleClasses += `.typography--${type}-${scale} { color: var(--sl-color-${type}-${scale}) } `;
      return scaleClasses;
    }, "");
    return typeClasses;
  }, "");
  return o(classes);
}
var typography_styles_default = r` ${component_styles_default} :host { display: contents; } .typography { font-family: var(--sl-font-sans); font-weight: var(--sl-font-weight-normal); margin: 0; padding: 0; cursor: inherit; word-break: break-word; } /** Weights */ .typography--weight-100 { font-weight: 100 !important; } .typography--weight-200 { font-weight: 200 !important; } .typography--weight-300 { font-weight: 300 !important; } .typography--weight-400 { font-weight: 400 !important; } .typography--weight-500 { font-weight: 500 !important; } .typography--weight-600 { font-weight: 600 !important; } .typography--weight-700 { font-weight: 700 !important; } .typography--weight-800 { font-weight: 800 !important; } .typography--weight-900 { font-weight: 900 !important; } /** heading styling */ .typography--heading-x-large { ${headingXLarge} } .typography--heading-large { ${headingLarge} } .typography--heading-medium { ${headingMedium} } .typography--heading-small { ${headingSmall} } .typography--heading-x-small { ${headingXSmall} } .typography--heading-xx-small { ${headingXXSmall} text-transform: uppercase; } .typography--heading-xxx-small { ${headingXXXSmall} text-transform: uppercase; } /** label styling */ .typography--label-large, .typography--label-medium, .typography--label-small, .typography--label-x-small, .typography--label-xx-small { display: inline-block; } .typography--label-large { ${labelLarge} } .typography--label-medium { ${labelMedium} } .typography--label-small { ${labelSmall} } .typography--label-x-small { ${labelXSmall} } .typography--label-xx-small { ${labelXXSmall} } /** Paragraph styling */ .typography--paragraph-large { ${paragraphLarge} } .typography--paragraph-medium { ${paragraphMedium} } .typography--paragraph-small { ${paragraphSmall} } .typography--paragraph-x-small { ${paragraphXSmall} } /** display styling */ .typography--display-large { ${displayLarge} } .typography--display-medium { ${displayMedium} } .typography--display-small { ${displaySmall} } .typography--table-header { ${tableHeader} } .typography--table-data { ${tableData} } ${generateVariantClasses()} `;

export {
  typography_styles_default
};
